import React from 'react';
import { Grid, Dropdown, Radio } from '@arrow-ds/react';

interface InputFieldProps {
  label: string;
  options: string[];
  onChange: (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => void;
  type: 'dropdown' | 'radio';
}

const InputField: React.FC<InputFieldProps> = ({
  label, options, onChange, type,
}) => {
  const optionFormatter = (opts: string[]) => opts.map((option) => ({
    label: option,
    value: option,
  }));

  return (
    <Grid row className="ds-mt-5">
      <Grid
        col={{
          lg: 4, md: 4, sm: 12, xl: 4, xs: 12,
        }}
      >
        <div className="ds-heading-5 ds-mt-0">{label}</div>
      </Grid>
      <Grid
        col={{
          lg: 8, md: 8, sm: 12, xl: 8, xs: 12,
        }}
      >
        {type === 'dropdown' ? (
          <Dropdown
            id={`dropdown-${label}`}
            mode="medium"
            name={`dropdown-${label}`}
            options={optionFormatter(options)}
            placeholder="Please select..."
            onChange={onChange}
          />
        ) : (
          <Radio
            id={`radio-${label}`}
            items={optionFormatter(options)}
            name={`radio-${label}`}
            testAttribute=""
            onChange={onChange}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default InputField;
